import { EmailAddressModel } from "../../personprofile/models/personprofile.model";
import { fail } from "assert";
import { TermsConditionStatus } from "../../termsandcondition/models/terms-condition.model";

export class AdminInvitationProfileModel {
  public personMasterHashId: string;
  public userName: string;
  public firstName: string;
  public lastName: string;
  public middleName: string;
  public countryCode1: string = "";
  public countryCode2: string = "";
  public telephone1: string;
  public telephone2: string;
  public isActive: boolean;
  public emailAddressModel: EmailAddressModel;
  public personPassword: string;
  public personConfirmPassword: string;
  public approvalCode: string;
  public validateLiceanceNumber: boolean = false;
  public isAccepted: boolean = false;
  public isPrivacyStatementAccepted: boolean = false;
  public allTermsConditionsList: TermsConditionStatus[] = [];
  public isDriver: boolean;
  public termsAndConditionsHashId: string;
  public privacyHashId: string;

  constructor() {
    this.emailAddressModel = new EmailAddressModel();
    this.allTermsConditionsList = [];
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/admin-invitation/models/admin-invitation.model.ts